import React from "react"
import { Link } from "gatsby"
//import styles from '../scss/index.scss'
import {
  FaFacebookF,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaEnvelopeOpen,
} from "react-icons/fa"
import ServiceData from "../data/service/ServiceMain.json"
import { slugify } from "../utils"

const getServiceData = ServiceData

export const Footer = ({ parentClass }) => {
  return (
    <footer className={`footer-area ${parentClass}`}>
      <div className="container">
        <div className="footer-top">
          <div className="footer-social-link">
            <ul className="list-unstyled">
              <li>
                <Link to="https://www.facebook.com/pixielweb/">
                  <FaFacebookF />
                </Link>
              </li>
              <li>
                <Link to="https://twitter.com/PixielApp">
                  <FaTwitter />
                </Link>
              </li>
              <li>
                <Link to="https://www.linkedin.com/company/pixielweb/">
                  <FaLinkedin />
                </Link>
              </li>
              <li>
                <Link to="https://www.youtube.com/channel/UCsTeFtvT47zRiWMoL_lDPaQ">
                  <FaYoutube />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-main">
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="footer-widget border-end">
                <div className="footer-newsletter">
                  <h2 className="title">
                    Iscriviti per ricevere offerte e news!!
                  </h2>
                  <p>
                    Sarò discreto, ti invierò informazioni utili e rispetterò la
                    tua privacy!
                  </p>
                  <form>
                    <div className="input-group">
                      <span className="mail-icon">
                        <FaEnvelopeOpen />{" "}
                      </span>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                      />
                      <button className="subscribe-btn" type="submit">
                        Iscriviti
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <div className="row">
                <div className="col-sm-6">
                  <div className="footer-widget">
                    <h6 className="widget-title">Servizi</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        {getServiceData.slice(0, 6).map((data, index) => (
                          <li key={index}>
                            <Link to={`/servizi/${slugify(data.title)}`}>
                              {data.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="footer-widget">
                    <h6 className="widget-title">Risorse</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        <li>
                          <Link to="/blog">Blog</Link>
                        </li>
                        <li>
                          <Link to="/progetti">Lavori in corso</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="footer-widget">
                    <h6 className="widget-title">Supporto</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        <li>
                          <Link to="/contatti">Contatti</Link>
                        </li>
                        <li>
                          {" "}
                          <Link to="/privacypolicy">Privacy Policy</Link>
                        </li>
                        <li>
                          {" "}
                          <Link to="/cookie-policy">Cookie Policy</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-6">
              <div className="footer-copyright">
                <span className="copyright-text">
                  © {new Date().getFullYear()}. All rights reserved by{" "}
                  <a href="https://pixiel.it/">Pixiel.it</a>.
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="footer-bottom-link">
                <ul className="list-unstyled">
                  <li>
                    <Link to="/privacypolicy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
